import React from 'react';

import WidgetComponent from '../../widget/WidgetComponent';
import Widget from '../../widget/Widget';
import Config from '../../config/Config';
import WidgetInterfaceTable from '../../widget/WidgetInterfaceTable';


import '../../css/analysis.css';

class NetworkManage extends WidgetComponent
{
    constructor(props)
    {
        super(props);

        let url = Config.getHermesPanoramaURL();
        let UID = Config.getHermesPanoramaUID();
        let entname = Widget.getSessionStorage("entname");

        this.state = {
            options:{
                'url':url,
                'records':5,
                'title':'ICP备案信息'
            },
            columns:[
                {name:'NAME', title:'网站名称', type:'string'},
                {name:'DOMAIN', title:'网站域名', type:'string'},
                {name:'WEBSITE', title:'网站首页地址', type:'string'},
                {name:'ICPNO', title:'网站许可证号', type:'date'},
                {name:'PRINCIPAL', title:'网站负责人', type:'date'}
            ],
            params :{
                'service':'getICPInfo',
                'user':UID,
                'ENTNAME' : entname
            }
        };

        this.onLoadToken = this.onLoadToken.bind(this);

        Config.getHermesAccess( this.onLoadToken );
    }

    /**
     * 获取 token 回调函数
     * @param {*} result 
     * @returns 
     */
    onLoadToken( result )
    {
        let { params } = this.state;
        
        if( result.status===0 )
        {
            params["access"] =  result.result.token;
 
            this.setState({params:params}); 
        }
        else
        {
            return ;
        }  
    }

    componentDidUpdate( )
    {
        let entname = Widget.getSessionStorage("entname");

        let { params } = this.state;

        if( params.ENTNAME!==entname )
        {
            this.state["params"]["ENTNAME"] = entname;
            Config.getHermesAccess( this.onLoadToken );
        }  
    }

    render() 
	{
        const {options, columns, params } = this.state;
        
        return(
            <div className="page">
                <div className="page-content page-overflow height-100 white padding-20">
                    <div className="content-top">
                        <WidgetInterfaceTable options={options} columns={columns} params={params} />
                    </div>
                </div>
            </div>
        );
    }

}

export default NetworkManage